// extracted by mini-css-extract-plugin
module.exports = {"image":"Image_image__3l-4a","imageError":"Image_imageError__1jZnt","imageStoryBookStyle":"Image_imageStoryBookStyle__19bkO"};